var exports = {
  "kL": "container__FbbjTU",
  "PC": "textarea__uSI8Hi",
  "qf": "placeholder__5mzV5v",
  "Hl": "readModeContainer__sdi40_",
  "IZ": "editIcon__5FGJ-q",
  "PJ": "readModeText__5Kp08D",
};

module.exports = exports;
